import type {AxiosError} from 'axios';
import {useMutation, useQueryClient, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {verifyIdentity} from '../../http';

export function useVerifyIdentity(
	options?: UseMutationOptions<void, AxiosError, void>,
): UseMutationResult<void, AxiosError, void> {
	const queryClient = useQueryClient();

	return useMutation<void, AxiosError, void>(() => verifyIdentity().then(() => undefined), {
		...options,
		onSuccess: (data, variables, context) => {
			queryClient.invalidateQueries({queryKey: ['identification', 'info']});
			options?.onSuccess?.(data, variables, context);
		},
	});
}
